import {
  TRESPONSE_TNA_DEFAULT_STEPS,
  TRESPONSE_TNA_TEMPLATE_LISTING,
  TRESPONSE_TNA_TEMPLATE_DETAILS,
} from '@monorepo/types';
import { TUserPaginationOption } from '@monorepo/ui';

export type TTnaTemplateState = {
  templateListingInfo: TRESPONSE_TNA_TEMPLATE_LISTING | null;
  userPaginationOption: TUserPaginationOption;
  tnaDefaultSteps: TRESPONSE_TNA_DEFAULT_STEPS | null;
  tnaDefaultStepsLoader: boolean;
  tnaTemplateDetails: TRESPONSE_TNA_TEMPLATE_DETAILS | null;
};

export const TTnaTemplatesActionType = {
  GetTnaTemplateList: 'GET_TNA_TEMPLATE_LIST' as const,
  GetTnaTemplateListSuccess: 'GET_TNA_TEMPLATE_LIST_SUCCESS' as const,
  GetTnaTemplateListFailure: 'GET_TNA_TEMPLATE_LIST_FAILURE' as const,
  ClearTnaTemplateDetails: 'CLEAR_TNA_TEMPLATE_DETAILS' as const,
  SetUserPaginationOption: 'SET_TNA_TEMPLATE_LIST_USER_PAGINATION_OPTION' as const,
  UpdateTnaTemplateName: 'UPDATE_TNA_TEMPLATE_NAME' as const,
  UpdateTnaTemplateNameSuccess: 'UPDATE_TNA_TEMPLATE_NAME_SUCCESS' as const,
  UpdateTnaTemplateNameFailure: 'UPDATE_TNA_TEMPLATE_NAME_FAILURE' as const,
  DeleteTnaTemplate: 'DELTE_TNA_TEMPLATE' as const,
  DeleteTnaTemplateSuccess: 'DELTE_TNA_TEMPLATE_SUCCESS' as const,
  DeleteTnaTemplateFailure: 'DELTE_TNA_TEMPLATE_FAILURE' as const,
  CopyTnaTemplate: 'COPY_TNA_TEMPLATE' as const,
  CopyTnaTemplateSuccess: 'COPY_TNA_TEMPLATE_SUCCESS' as const,
  CopyTnaTemplateFailure: 'COPY_TNA_TEMPLATE_FAILURE' as const,
  SetTnaDefaultStepsLoader: 'SET_TNA_DEFAULT_STEPS_LOADER' as const,
  GetTnaDefaultSteps: 'GET_TNA_DEFAULT_STEPS' as const,
  GetTnaDefaultStepsSuccess: 'GET_TNA_DEFAULT_STEPS_SUCCESS' as const,
  GetTnaDefaultStepsFailure: 'GET_TNA_DEFAULT_STEPS_FAILURE' as const,
  CreateTnATemplate: 'CREATE_TNA_TEMPLATE' as const,
  CreateTnATemplateSuccess: 'CREATE_TNA_TEMPLATE_SUCCESS' as const,
  CreateTnATemplateFailure: 'CREATE_TNA_TEMPLATE_FAILURE' as const,
  GetTnaTemplateDetails: 'GET_TNA_TEMPLATE_DETAILS' as const,
  GetTnaTemplateDetailsSuccess: 'GET_TNA_TEMPLATE_DETAILS_SUCCESS' as const,
  GetTnaTemplateDetailsFailure: 'GET_TNA_TEMPLATE_DETAILS_FAILURE' as const,
  AddEditTnaTemplateStep: 'ADD_EDIT_TNA_TEMPLATE_STEP' as const,
  AddEditTnaTemplateStepSuccess: 'ADD_EDIT_TNA_TEMPLATE_STEP_SUCCESS' as const,
  AddEditTnaTemplateStepFailure: 'ADD_EDIT_TNA_TEMPLATE_STEP_FAILURE' as const,
  DeleteTnaTemplateStep: 'DELTE_TNA_TEMPLATE_STEP' as const,
  DeleteTnaTemplateStepSuccess: 'DELTE_TNA_TEMPLATE_STEP_SUCCESS' as const,
  DeleteTnaTemplateStepFailure: 'DELTE_TNA_TEMPLATE_STEP_FAILURE' as const,
  DownloadTnaTemplateDetails: 'DOWNLOAD_TNA_TEMPLATE_DETAILS' as const,
  DownloadTnaTemplateDetailsSuccess: 'DOWNLOAD_TNA_TEMPLATE_DETAILS_SUCCESS' as const,
  DownloadTnaTemplateDetailsFailure: 'DOWNLOAD_TNA_TEMPLATE_DETAILS_FAILURE' as const,
  AssignTnaToOrder: 'ASSIGN_TNA_TO_ORDER' as const,
  AssignTnaToOrderSuccess: 'ASSIGN_TNA_TO_ORDER_SUCCESS' as const,
  AssignTnaToOrderFailure: 'ASSIGN_TNA_TO_ORDER_FAILURE' as const,
};
